import { ObjectListRequestType, ObjectListResponseType } from '../ObjectListResponseTypes'

interface DocumentResponse {
  documentId: number
  name: string
  size: number
  version: number
  type: string
  category: string
  fileExtension: string
  uploadedBy: string
  uploadedOn: string
  comment: string
}

interface DocumentRequestBody extends ObjectListRequestType {}

interface DocumentListResponse extends ObjectListResponseType {
  documents: DocumentResponse[]
}

const isDocumentListResponse = (response: any): response is DocumentListResponse => {
  return Array.isArray(response) && (response.length === 0 || 'documentId' in response[0])
}
export type { DocumentResponse, DocumentRequestBody }
export { isDocumentListResponse }
